import styled, { css } from 'styled-components';
import { darken, lighten, transparentize } from 'polished';
import { Form as FormBase } from '@unform/web';

export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;


  >header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    div{
      display: flex;
      align-items: center;
      min-width: 200px;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  caret-color: transparent;

  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        padding: 10px 0px;

        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};

        button {
          margin: 0;
        }
      }

      &:hover {
        transition: all 0.25s ease;
        /* cursor: pointer; */
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background-color: ${props =>
                  lighten(0.03, props.theme.cardBackgroud)};
              `
            : css`
                background-color: ${props =>
                  darken(0.03, props.theme.cardBackgroud)};
              `}
      }
    }
  }
`;

export const Align = styled.div`
  justify-content: ${({ $align }) =>
    $align === 'right' ? 'flex-end' : 'flex-start'};

  display: flex;
  color: ${props => props.theme.fontColor};
  font-size: 1.0625rem;
  font-weight: 400 !important;
`;

export const Content = styled.div`
  padding: 0 15px 0 15px;
  flex: 1 1;
`;
export const FormContent = styled.div`
  flex: 1 1;
`;
export const FormActions = styled.div``;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  .ButtonGroup {
    display: flex;
    justify-content: space-between;
    align-self: flex-end;
    /* margin: 0 1rem; */
  }
  section {
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;
